import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SiteSettingsContext = createContext({
  settings: {
    whatsapp: "05423504436",
    phone: "0542 350 44 36",
    email: "info@guvenkimya.com",
    address: "Hacılar Harmanı 50. Cadde No:11 AKSARAY Merkez",
    instagram: "",
    linkedin: "",
    map_embed: "",
  },
  reload: () => {},
});

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    whatsapp: "05423504436",
    phone: "0542 350 44 36",
    email: "info@guvenkimya.com",
    address: "Hacılar Harmanı 50. Cadde No:11 AKSARAY Merkez",
    instagram: "",
    linkedin: "",
    map_embed: "",
  });

  const load = async () => {
    try {
      const { data } = await api.get("/site-settings");
      if (data && Object.keys(data).length > 0) {
        setSettings((prev) => ({ ...prev, ...data }));
      }
    } catch (e) {
      // keep defaults
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <SiteSettingsContext.Provider value={{ settings, reload: load }}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export const useSiteSettings = () => useContext(SiteSettingsContext);

export function whatsappLink(number, msg = "Merhaba, ürünleriniz hakkında bilgi almak istiyorum") {
  if (!number) return "#";
  const cleaned = String(number).replace(/[^0-9]/g, "");
  // assume Turkish numbers; if starts with 0, replace with 90
  const intl = cleaned.startsWith("0") ? `90${cleaned.slice(1)}` : cleaned;
  return `https://wa.me/${intl}?text=${encodeURIComponent(msg)}`;
}
